
(function () {
  function closeDrawer(host) {
    if (!host) return;
    try {
      if (typeof host.hide === 'function') {
        host.hide();
        return;
      }
    } catch (e) {}
    host.dispatchEvent(new CustomEvent('dialog:force-close', { bubbles: true, cancelable: true, composed: true }));
    host.removeAttribute('open');
    host.setAttribute('aria-hidden', 'true');
  }

  function findDrawerFromEvent(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    for (var i = 0; i < path.length; i += 1) {
      var node = path[i];
      if (node && node.matches && node.matches('cart-drawer, header-sidebar, x-drawer, dialog-element')) return node;
    }
    return event.target && event.target.closest && event.target.closest('cart-drawer, header-sidebar, x-drawer, dialog-element');
  }

  document.addEventListener('click', function (event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    var clickedClose = path.some(function (node) {
      return node && node.matches && node.matches('[data-regista-force-close], .regista-drawer-close, button[is="dialog-close-button"], [part~="close-button"]');
    });
    if (!clickedClose) return;
    var drawer = findDrawerFromEvent(event);
    if (!drawer) return;
    event.preventDefault();
    closeDrawer(drawer);
  }, true);
})();
